import React, { useState, useEffect } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import { QueryClient, QueryClientProvider } from "react-query";

import { CartingOrderAllColumn, CartingOrderClaimColumn, CartingOrderColumn } from "../components/ag-table/columns";

import ReactTablePagination from "../components/ag-table/ReactTablePagination";
import TableFilter from "../components/ag-table/TableFilter";

import {
  reducer,
  PAGE_CHANGED,
  PAGE_SIZE_CHANGED,
  PAGE_SORT_CHANGED,
  PAGE_FILTER_CHANGED,
  TOTAL_COUNT_CHANGED,
  PAYLOAD_CHANGED,
} from "../components/ag-table/ag-reducer";
import ApiAgTable from "../components/ag-table/api_ag-table";
import {
  AgmodalStore,
  configStore,
  loginStore,
  modalStore,
  quoteStore,
  customerStore,
  quotatationImportStore,
  initiaizeCommonState,
  contractsStore,
  creditformStore,
  EntityV2Store,
  entityStore,
  bookingsStore,
} from "../state/CommonState";
import { useSnapshot } from "valtio";
import TableHead from "../util/dataTable";
import { loader } from "../util/loader";
import { cartingStore } from "./cartingStore.js";
import CartingOrderApi from "../state/cartingorder-api.js";
import { enquiryStore } from "../enquiry/enquiry-data.js";
import BookingsApi from "../state/bookings-api.js";
import QuoteCalcV2 from "../util/quote-calc-v2.js";

const queryClient = new QueryClient();

const initialState = {
  queryPageIndex: 0,
  queryPageSize: 20,
  totalCount: 0,
  queryPageFilter: "",
  queryPageSortBy: [],
  queryPayload: {},
};

const DataTable = (props) => {
  useSnapshot(cartingStore);
  useSnapshot(AgmodalStore);
  useSnapshot(configStore);
  useSnapshot(bookingsStore)
  useSnapshot(entityStore)
  useSnapshot(contractsStore)
  useSnapshot(enquiryStore)
  const [selectedType, setSelectedType] = useState("Carted");

  let column = CartingOrderColumn;

  if(selectedType=='Claimed'){
    column = CartingOrderClaimColumn
  }
  if(selectedType=='ALL'){
    column = CartingOrderAllColumn
  }

  const [keyword, setKeyword] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [data1, setData1] = useState({ results: [] });
  const onClickFilterCallback = (filter) => {
    setKeyword(filter);
  };
  let columns = column;
  const [
    {
      queryPageIndex,
      queryPageSize,
      totalCount,
      queryPageFilter,
      queryPageSortBy,
      queryPayload,
    },
    dispatch,
  ] = React.useReducer(reducer, initialState);

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    if (hasMounted && AgmodalStore.apiCall) {
      console.log(
        "hhhh",
        queryPayload,
        "hhhh",
        queryPageIndex,
        "hhhh",
        queryPageSize,
        "hhhh",
        queryPageFilter,
        "hhhh",
        queryPageSortBy
      );
      loader.show();
      ApiAgTable.cartingorderData(
        queryPageIndex,
        queryPageSize,
        queryPageFilter,
        queryPageSortBy,
        queryPayload
      ).then((res) => {
        res
          .clone()
          .json()
          .then(
            (res) => {
              if (
                JSON.stringify(data1.results) !== JSON.stringify(res.results)
              ) {
                if (
                  JSON.stringify(data1) !== JSON.stringify(res) &&
                  res.results &&
                  res.results.length > 0
                ) {
                  setData1(res);
                } else {
                  setData1({ count: 0, results: [] });
                }
              }
              loader.hide();
            },
            (err) => {
              console.log(err);
            }
          );
      });
    } else {
      setHasMounted(true);
    }
  }, [
    queryPayload,
    queryPageIndex,
    queryPageSize,
    queryPageFilter,
    queryPageSortBy,
    hasMounted,
    AgmodalStore.apiCall,
    refresh
  ]);

  const totalPageCount = Math.ceil(totalCount / queryPageSize);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    pageCount,
    pageOptions,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns,
      data: data1?.results,
      initialState: {
        pageIndex: queryPageIndex,
        pageSize: queryPageSize,
        sortBy: queryPageSortBy,
      },
      manualPagination: true,
      pageCount: data1 ? totalPageCount : null,
      autoResetSortBy: false,
      autoResetExpanded: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination
  );

  const manualPageSize = [];

  useEffect(() => {
    dispatch({ type: PAGE_CHANGED, payload: pageIndex });
  }, [pageIndex, gotoPage]);

  useEffect(() => {
    dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize });
    gotoPage(0);
  }, [pageSize, gotoPage]);

  useEffect(() => {
    dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy });
    gotoPage(0);
  }, [sortBy, gotoPage]);

  useEffect(() => {
    if (keyword.length === 0) {
      dispatch({ type: PAGE_FILTER_CHANGED, payload: keyword });
      gotoPage(0);
    }
  }, [keyword]);
  useEffect(() => {
    dispatch({ type: PAYLOAD_CHANGED, payload: { status: selectedType } });
    gotoPage(0);
  }, [selectedType]);

  const onClickSearch = () => {
    if (keyword.length > 0) {
      dispatch({ type: PAGE_FILTER_CHANGED, payload: keyword });
      gotoPage(0);
    } else {
      configStore.setModalMessage(`Please Provide Valid Input`);
    }
  };

  React.useEffect(() => {
    if (data1?.count) {
      dispatch({
        type: TOTAL_COUNT_CHANGED,
        payload: data1.count,
      });
    }
  }, [data1?.count]);

  return (
    <>
      <h1 className="title">Carting Sheet</h1>

      <nav className="level">
        <div className="level-left">
          <p className="level-item">
            <a
              className="button"
              style={{
                backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                color: "#fff",
              }}
              onClick={() => {
                cartingStore.disable=false
                cartingStore.setValidation()
                cartingStore.current = JSON.parse(JSON.stringify(cartingStore.new));
                AgmodalStore.modalPage = "CartingOrder";
                AgmodalStore.apiCall = false;
                configStore.modalVisible = false;
                AgmodalStore.pageVisible = true;
                console.log("New clicked");
              }}
            >
              New
            </a>
          </p>
          <div class="level-item">
            <TableFilter
              onClickSearch={onClickSearch}
              onClickFilterCallback={onClickFilterCallback}
              defaultKeyword={keyword}
              deBouncingFlag={true}
            />
          </div>
        </div>
      </nav>
      <div style={{ width: "100%" }}>
        <div className="w-full h-[40px] bg-blue-dark rounded-t-md flex flex-row">
          {["Carted", "On-hold",'Claimed','ALL'].map((type, i) => (
            <div
              onClick={() => {
                setSelectedType(type);
              }}
              className={` h-full text-white font-bold text-[18px] flex items-center justify-center w-[80px] uppercase hover:cursor-pointer ${
                type === "Carted" && "rounded-tl-md"
              } ${type === selectedType && "bg-yellow"}`}
              style={{ width: "10%" }}
            >
              {type}
            </div>
          ))}
        </div>
      </div>
      <div className="box" style={{height:"calc(100vh - 230px)"}}>
      <div
        style={{height:"100%", overflow: "auto", margin: "0px" }}
      >
        <table className="table is-fullwidth is-small ">
          <TableHead headerGroups={headerGroups} sort={true} />
          <tbody
            className="contractlist"
            style={{ fontSize: "0.9rem", position: "relative" }}
            {...getTableBodyProps()}
          >
            {page.map((row, i) => {
              prepareRow(row);
              let r = false
              let l = row['original']['hazardous']
              if(l!=undefined && l ==true){
                r = true
              }
              return (
                <tr {...row.getRowProps()} style={r?{background:"#ff0000",color:"#ffffff"}:{}}>
                  {row.cells.map((cell) => {
                    {
                      let e = cell['row']['original']
                      switch (cell["column"]["Header"]) {
                        case "CartingOrder Ref. #":
                          return <td
                          ><a  onClick={() => {
                                  loader.show()
                                  const callback = (d)=>{
                                      cartingStore.disable=true
                                      cartingStore.update=false
                                      cartingStore.current = JSON.parse(JSON.stringify(d));
                                      AgmodalStore.modalPage = "CartingOrder";
                                      AgmodalStore.apiCall = false;
                                      configStore.modalVisible = false;
                                      AgmodalStore.pageVisible = true;
                                      loader.hide()
                                  }
                                  CartingOrderApi.getcartingorderbyid(e._id,callback)
                                            
                              }}>{e._id}</a>
                          </td>
                        case "Booking. #":
                          return <td
                          ><a  onClick={() => {
                                  BookingsApi.getBookingWithEntitie(e.bookingId, (data) => {
                                        console.log("check-------->", data)
                                        bookingsStore.current = data
                                        let en = data.Entities
                                        en['branch']= [data.Branches]
                                        entityStore.entityRec.set(en)
                                        EntityV2Store.EntityRec.set(en)
                                        if(en?.isCreditCustomer==='Yes'){
                                            creditformStore.CreditformRec.set(data?.Credit)
                                        }
                                        contractsStore.current = data.contract
                                        contractsStore.current = new QuoteCalcV2(contractsStore.current).recalc()
                                        enquiryStore.initializeWithConract(data.contract)
                                        // bookingsStore.currentBookingsListComponent = 'view'
                                        AgmodalStore.modalPage = "ViewEnquiryBooking-v3"
                                        AgmodalStore.pageVisible = true
                                        AgmodalStore.apiCall = false
                                    })    
                              }}>{e.bookingId}</a>
                          </td>
                        case "Shipping Bill No":
                          return <td
                          >{(selectedType=="Claimed")?<a  onClick={() => {
                                  loader.show()
                                  const callback = (d)=>{
                                      cartingStore.disable=true
                                      cartingStore.update=false
                                      cartingStore.current = JSON.parse(JSON.stringify(d));
                                      AgmodalStore.modalPage = "CartingOrder";
                                      AgmodalStore.apiCall = false;
                                      configStore.modalVisible = false;
                                      AgmodalStore.pageVisible = true;
                                      loader.hide()
                                  }
                                  CartingOrderApi.getcartingorderbyid(e._id,callback)
                                            
                              }}>{e.shippingBillNo}</a>:<>{e.shippingBillNo}</>}
                          </td>
                        case "Actions":
                          return (
                            <td>
                              <div
                                class="dropdown post-options is-right is-hoverable "
                                onClick={null}
                              >
                                <div class="dropdown-trigger">
                                  <button
                                    class="button"
                                    aria-haspopup="true"
                                    aria-controls="dropdown-menu-post"
                                  >
                                    <span class="icon is-small">
                                      <i
                                        class="fas fa-ellipsis-h"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </button>
                                </div>
                                <div
                                  class="dropdown-menu"
                                  id="dropdown-menu-post"
                                  role="menu"
                                >
                                  <div class="dropdown-content">
                                    {['Carted','Claimed','ALL'].indexOf(e.status)!=-1 && <a
                                            class="dropdown-item"
                                            onClick={() => {
                                            loader.show()
                                            const callback = (d)=>{
                                                if(['Claimed','ALL'].indexOf(e.status)!=-1){
                                                  cartingStore.disable=true
                                                  cartingStore.update=true
                                                }else{
                                                  cartingStore.disable=false
                                                  cartingStore.update=false
                                                }
                                                cartingStore.setValidation()
                                                cartingStore.current = JSON.parse(JSON.stringify(d));
                                                AgmodalStore.modalPage = "CartingOrder";
                                                AgmodalStore.apiCall = false;
                                                configStore.modalVisible = false;
                                                AgmodalStore.pageVisible = true;
                                                loader.hide()
                                            }
                                            CartingOrderApi.getcartingorderbyid(e._id,callback)
                                            }}
                                          >
                                            Edit
                                          </a>}
                                          {
                                            e.status == "Carted" && <>
                                          {
                                            (process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE!='agraga')?<a
                                            class="dropdown-item"
                                            onClick={() => {
                                            loader.show()
                                            const callback = (d)=>{
                                                cartingStore.disable=false
                                                cartingStore.current = JSON.parse(JSON.stringify(d));
                                                enquiryStore.initializeWithCarting(cartingStore.current)
                                                AgmodalStore.modalPage = "cartingbooking";
                                                AgmodalStore.apiCall = false;
                                                configStore.modalVisible = false;
                                                AgmodalStore.pageVisible = true;
                                                loader.hide()
                                            }
                                            CartingOrderApi.getcartingorderbyid(e._id,callback)
                                            }}
                                          >
                                            Claim Shipment
                                          </a>:""
                                          }
                                          
                                          <a
                                            class="dropdown-item"
                                            onClick={() => {
                                            loader.show();
                                            let callback = (d) => {
                                              AgmodalStore.pageVisible = false;
                                              AgmodalStore.apiCall = true;
                                              setHasMounted(true);
                                              setRefresh(refresh?false:true)
                                              configStore.setModalMessage(
                                                `The carting order status has been changed to 'On Hold'. (${e._id})`
                                              );
                                              loader.hide()
                                            };
                                            CartingOrderApi.getcartingorderonhold(
                                              e._id,
                                              callback
                                            );
                                            }}
                                          >
                                            On-hold
                                          </a></>
                                          }
                                          {
                                            e.status == "On-hold" && <a
                                            class="dropdown-item"
                                            onClick={() => {
                                            loader.show();
                                            let callback = (d) => {
                                              AgmodalStore.pageVisible = false;
                                              AgmodalStore.apiCall = true;
                                              setHasMounted(true);
                                              setRefresh(refresh?false:true)
                                              configStore.setModalMessage(
                                                `The carting order status has been changed to 'In-transit'. (${e._id})`
                                              );
                                              loader.hide()
                                            };
                                            CartingOrderApi.getcartingorderintransit(
                                              e._id,
                                              callback
                                            );
                                            }}
                                          >
                                            Make It Available
                                          </a>
                                          }
                                  </div>
                                </div>
                              </div>
                            </td>
                          );
                        default:
                          return (
                            <td {...cell.getCellProps()}>
                              <span>{cell.render("Cell")}</span>
                            </td>
                          );
                      }
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <ReactTablePagination
          page={page}
          gotoPage={gotoPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageOptions={pageOptions}
          pageSize={pageSize}
          pageIndex={pageIndex}
          pageCount={pageCount}
          setPageSize={setPageSize}
          manualPageSize={manualPageSize}
          dataLength={totalCount}
          rows={rows}
        />
      </div>
      </div>
    </>
  );
};

const CartingOrderList = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <DataTable />
    </QueryClientProvider>
  );
};

export default CartingOrderList;
